<div class='delivery-events-tab-2-part'>
	This is tab 2
</div>